/**
 * 请求防乱序守卫 (ALENS-107 #5)。
 *
 * 页面切换 / 标的切换这类"同一个 load 被连续触发"的场景，慢请求可能后到并
 * 覆盖新状态。用单调序号判定"我是不是最新一次"：
 *
 *   const latest = useLatestRequest()
 *   async function load() {
 *     const isLatest = latest.next()
 *     const data = await fetchX()
 *     if (!isLatest()) return   // 已被更新的请求取代，丢弃过期响应
 *     state.value = data
 *   }
 */
export function useLatestRequest() {
  let seq = 0

  /** 开始一次新请求, 返回"仍是最后一次"的判定函数 */
  function next(): () => boolean {
    const mine = ++seq
    return () => mine === seq
  }

  return { next }
}
